import * as ewe from "@eyeo/webext-ad-filtering-solution";
import ServerMessages from "~/servermessages";
import { getMatchingDomain, hasUbo } from "./shared";
async function handleBTAADetectionEvent(details) {
    const domain = await getMatchingDomain(details.siteId);
    if (!domain) {
        return;
    }
    let packedDetails = 0;
    packedDetails |= (await hasUbo()) ? 1 : 0;
    packedDetails <<= 1;
    packedDetails |= details.isAAPV ? 1 : 0;
    packedDetails <<= 1;
    packedDetails |= details.ab ? 1 : 0;
    packedDetails <<= 1;
    packedDetails |= details.acceptable ? 1 : 0;
    ServerMessages.recordAnonymousMessage("btaa_detection", "stats", null, {
        misc_text: domain,
        sid: details.sessionId,
        var: packedDetails,
    });
}
export function start() {
    ewe.cdp.onBTAADetectionEvent.addListener(handleBTAADetectionEvent);
}
